import React from 'react'
import Hero from '../components/NewHome/HeroSection/Hero'
import JourneySection from '../components/NewHome/JourneySection/JourneySection'
import Functionalities from '../components/NewHome/Functionalities/Functionalities'
import Benefits from '../components/NewHome/Benefits/Benefits'
import Testimonials from '../components/NewHome/Testimonials/Testimonials'
import Team from '../components/NewHome/Team/Team'
import Blogs from '../components/NewHome/Blogs/Blogs'

const Home = () => {
  return (
    <div>
      <Hero />
     <JourneySection />
    <Functionalities />
     <Benefits />
        <Testimonials />
       <Team />
      <Blogs />
    </div>
  )
}

export default Home
